(function (angular) {
  angular.module('acme.common.factory.node', []).factory('NodeFactory', NodeFactory);

  NodeFactory.$inject = [];

  function NodeFactory() {
    return Node;
  }

  /**
   * @param {{ id: string; parent: Node | null; children: Node[]; value: T | null }} options
   */
  function Node(options) {
    var self = this;
    options = options || {};

    self.id = options.id || null;
    self.parent = options.parent || null;
    self.value = options.value || null;
    self.children = [];

    self.isRoot = function () {
      return self.parent == null;
    };

    self.isLeaf = function () {
      return self.children.length === 0;
    };

    self.add = function (node) {
      self.children.push(node);
    };

    self.traverse = function (callbackFn) {
      var queue = [this];

      internalTraverse(callbackFn, queue);
    };

    self.traverseChildren = function (callbackFn) {
      var queue = self.children.map(function (child) {
        return child;
      });

      internalTraverse(callbackFn, queue);
    };
  }

  /**
   *
   * @param {(node: Node) => void} callbackFn
   * @param {Array<TreeNodeController>} queue
   */
  function internalTraverse(callbackFn, queue) {
    queue = Array.isArray(queue) ? queue : [];

    while (queue.length) {
      var node = queue.shift();

      if (typeof callbackFn === 'function') {
        callbackFn(node);
      }

      if (node) {
        node.children.forEach(function (child) {
          queue.push(child);
        });
      }
    }
  }
})(window.angular);
